export const environment = {
  production: true,
  apiUrl: 'https://tracey-prod-6b98eac1c8fad5e7fa6493b8d82e4fc3.traceysport.com',
  internalServicesAddress: 'https://tracey-prod-6b98eac1c8fad5e7fa6493b8d82e4fc3.traceysport.com',
  googleLoginProviderId: '918624079894-kug8r6t6go32n746040i4jhuur5su4tq.apps.googleusercontent.com',
  facebookLoginProviderId: '1131369544436247',
  toastDurationTime: 10000,
  fullTextSearchDelay: 100,

  headquartersLat: 45.80632463407991,
  headquartersLng: 15.98671633558226,
  headquartersName: 'Stotinka Ltd for electronic timing',
  headquartersStreet: 'Domagojeva 21',
  headquartersPostalNumber: 'HR-10000',
  headquartersCity: 'Zagreb',
  headquartersCountry: 'Croatia',

  contactMail: 'info@traceysport.com',
  ceo: 'Zoran Besak',

  complaintsMail: 'prigovori@traceysport.com',


  contactManagement: 'Zoran Besak, CEO',
  contactManagementMail: 'zoran.besak@traceysport.com',
  contactManagementPhone: '+385 91 230 9973',

  contactHelpdeskMail: 'info@traceysport.com',
  contactHelpdeskPhone: '+385 99 3455 678',

  courtRegistryLink: 'https://sudreg.pravosudje.hr/registar/f?p=150:28:0::NO:28:P28_SBT_MBS:080940043',
  courtNumber: '080940043',
  taxNumber: '21101618444',

  bankLink: 'https://www.pbz.hr',
  bankName: 'Privredna banka Zagreb d.d.',
  bankStreet: 'Radnička cesta 50',
  bankPostalNumber: 'HR-10000',
  bankCity: 'Zagreb',
  bankCountry: 'Croatia',
  bankSwiftCode: 'PBZGHR2X',
  bankIbanCode: 'HR3723400091110687781',

  lengthDropdownMeasurementUnit: 'km',
  liveResultRequestInterval: 3000,
  debounceActionInterval: 300,
  maxFileSize: 2 * 1024 * 1024,
  maxImageSize: 4 * 1024 * 1024 * 1024,  // 4 GB in bytes
  ibanMinLength: 11,
  swiftCodeLength: 7,
  dayInSeconds: 24 * 60 * 60,
  site_name: 'TraceySport',
  google_site_verification: 'uN-OTH3_sKjMHM7Qs5Bd23BTH2j-PZaBcji7uE5VDwY',
  assetsImagesPath: 'https://images.traceysport.com',
  appName: "Tracey Web",
  cookie_validity_date: new Date("2025-05-13"),
  intelectual_property_validity_date: new Date("2025-05-13"),
  terms_and_conditions_validity_date: new Date("2025-05-13"),
  eventImageRequired: false,
  encodingKey: 'd4f2b7a8e5c6f3d9b2a5c7e8f9d6b2a5',
  isMapVisible: false,
  isLeagueVisible: true,
  isDashboardVisible: false,
  googleAnalyticsMeasurementID: 'G-NQD7ZXY09L',
};
